import qs from 'qs';

export default function pointsReducer(state = {
    point_expiry: [],
    transactions: {
        list: [],
        links: {},
        paging: {
            number: 1,
            size: 20,
        }
    },
    meta: {
      'point-pots': []
    },
    details: {},
    fetching: false,
    fetched: false,
    errors: {}
  }, action) {
    switch (action.type) {
      case 'GET_POINTS_EXPIRY_PENDING':
      case 'GET_POINTS_DETAILS_PENDING':
      case 'GET_POINTS_TRANSACTIONS_PENDING': {
        return {...state, fetching: true, fetched: false}
      }
      case 'GET_POINTS_EXPIRY_FULFILLED': {
        return {
          ...state,
          fetching: false,
          fetched: true,
          point_expiry: action.payLoad,
        }
      }
      case 'GET_POINTS_TRANSACTIONS_FULFILLED': {
        const lastPage = action.payLoad.links.last;
        let page = state.transactions.paging;
        if (lastPage) {
              page = qs.parse(lastPage.split('?')[1]).page;
            } else if (Object.keys(action.payLoad.links).length === 0) {
              page = {
                      number: 1,
                      size: 20,
                  };
            }
        return {
          ...state,
          fetching: false,
          fetched: true,
          transactions: {
              ...state.transactions,
              list: action.payLoad.data,
              links: action.payLoad.links,
              paging: page
          },
          meta: action.payLoad.meta
        }
      }
      case 'GET_POINTS_DETAILS_FULFILLED': {
        return {
          ...state,
          fetching: false,
          fetched: true,
          details: action.payLoad,
        }
      }
      case 'CLEAR_POINTS_DETAILS': {
        return {
          ...state,
          details: {},
        }
      }
      case 'GET_POINTS_EXPIRY_REJECTED':
      case 'GET_POINTS_DETAILS_REJECTED':
      case 'GET_POINTS_TRANSACTIONS_REJECTED': {
        // return {...state, errors: action.payLoad.errors}
      }
      default:
    }
  
    return {...state};
  }
  


// WEBPACK FOOTER //
// ./src/reducers/pointsReducer.js